import { IconType } from '../../constants';

import PaintBrushIcon from '@heroicons/react/20/solid/PaintBrushIcon';
import SparklesIcon from '@heroicons/react/20/solid/SparklesIcon';

export const SubscriptionContainerAnchor = 'subscription-slideout-container_top';

const VITE_MEMBER_SUBSCRIPTION_SEMI_ANNUAL_PRICE_ID = import.meta.env.VITE_MEMBER_SUBSCRIPTION_SEMI_ANNUAL_PRICE_ID;
const VITE_MEMBER_SUBSCRIPTION_MONTHLY_PRICE_ID = import.meta.env.VITE_MEMBER_SUBSCRIPTION_MONTHLY_PRICE_ID;

export const BILLING_FREQUENCIES: Array<Frequency> = [
  { value: 'monthly', label: 'Monthly', priceSuffix: 'per month' },
  { value: 'semiAnnually', label: 'Semi-Annually', priceSuffix: 'every 6 months' },
];

export type Frequency = {
  value: 'monthly' | 'semiAnnually';
  label: string;
  priceSuffix: string;
};

export const SUBSCRIPTION_TIERS: Array<Tier> = [
  {
    name: 'Pro Member',
    id: 'tier-member',
    badge: 'Member',
    price: { monthly: '$5', semiAnnually: '$25' },
    priceId: {
      monthly: VITE_MEMBER_SUBSCRIPTION_MONTHLY_PRICE_ID,
      semiAnnually: VITE_MEMBER_SUBSCRIPTION_SEMI_ANNUAL_PRICE_ID,
    },
    features: [
      { label: 'Access to All Themes' },
      { label: 'Unlimited referrals' },
      { label: 'Priority in search results' },
      { label: '50% discount for lifetime access for themes in the theme store' },
    ],
    tierTitle: 'Member',
    Icon: PaintBrushIcon,
  },
];

export type Tier = {
  name: string;
  id: 'tier-member';
  badge: string;
  price: { monthly: string; semiAnnually: string };
  priceId: { monthly: string; semiAnnually: string };
  features: Array<{ label: string; isCommon?: boolean }>;
  tierTitle: string;
  Icon: IconType;
};
